import { createActionGroup, emptyProps, props } from '@ngrx/store'

export const AiInspectorActions = createActionGroup({
  source: 'AiInspector',
  events: {
    getWarningsMessages: props<{
      application_id: string
      application_version: string
      process_id: string
      category: string
    }>(),
    getWarningsMessagesSuccess: props<{
      warnings: any[]
    }>(),
    getWarningsCount: props<{
      application_id: string
      application_version: string
      process_id: string
      category: string
    }>(),
    getWarningsCountSuccess: props<{
      count: number
    }>(),
    getRules: props<{
      category: string
    }>(),
    getRulesSuccess: props<{
      rules: any[]
    }>(),
    checkProcess: props<{
      application_id?: string
      application_version?: string
      process_id?: string
      session_id?: string
    }>(),
    checkProcessSuccess: emptyProps(),

    // SSE streaming inspection
    inspectProcess: props<{ processContext: any }>(),
    inspectProcessStream: props<{ response: any }>(),
    inspectProcessComplete: props<{ summary: any }>(),
    inspectProcessFailure: props<{ error: any }>(),
    getWarningsCountFailure: props<{
      error: any
    }>(),
    getWarningsMessagesFailure: props<{
      error: any
    }>(),
    getRulesFailure: props<{
      error: any
    }>(),
    checkProcessFailure: props<{
      error: any
    }>(),
    updateWarningStatus: props<{
      warning_id: string
      status: 'PENDING' | 'APPROVED' | 'REJECTED' | 'RESOLVED'
    }>(),
    updateWarningStatusSuccess: emptyProps(),
    updateWarningStatusFailure: props<{
      error: any
    }>(),
  },
})
